module.exports = __webpack_public_path__ + "assets/img/goods_adv4.6b4b51ce.jpg";